/* eslint-disable no-void */

import * as vp from 'vopay';

import { useEffect, useState } from 'react';
import axios from 'axios';

import { useDataFetchIndicator } from '..';

import vopayApi from '../../services/api.config';

type HookProps = {
  api: vp.Api;
};

export type ChangePasswordRequest = {
  login: string;
  newPassword: string;
  shouldSendEmail: boolean;
};

export type ChangePasswordResponse = {
  success: boolean;
  errorMessage: string;
  username: string;
};

type ReturnTuple = [ChangePasswordResponse | undefined, (requestParams: ChangePasswordRequest) => void, () => void];

function usePostPartenerAccountUsersChangePassword({ api }: HookProps): ReturnTuple {
  const source = axios.CancelToken.source();

  const [params, setParams] = useState<ChangePasswordRequest>();
  const [response, setResponse] = useState<ChangePasswordResponse>();
  const [shouldSendRequest, setSendRequest] = useState(false);
  const [, setDataFetchingInfo] = useDataFetchIndicator();

  useEffect(() => {
    const sendRequest = async (requestParams: ChangePasswordRequest) => {
      setDataFetchingInfo(true, 'updating password', 'fullScreen');
      const { Success, ErrorMessage, Username } = await api.postPartnerAccountUsersChangePassword(
        buildParams(requestParams),
        source,
      );

      const res = {
        success: Success,
        errorMessage: ErrorMessage || '',
        username: Username || '',
      };

      setResponse(res);
      setSendRequest(false);
      setDataFetchingInfo(false);

      return () => {};
    };

    if (params && shouldSendRequest) void sendRequest(params);

    return () => {
      source.cancel();
    };
  }, [shouldSendRequest]);

  return [
    response,
    (requestParams: ChangePasswordRequest) => {
      setParams(requestParams);
      setSendRequest(true);
    },
    () => {
      setResponse(undefined);
      setSendRequest(false);
    },
  ];

  function buildParams(requestParams: ChangePasswordRequest): vp.PartnerAccountUsersChangePasswordRequest {
    return {
      Username: requestParams.login,
      NewPassword: requestParams.newPassword,
      SendEmail: requestParams.shouldSendEmail,
    };
  }
}

export default vopayApi.withApiHook<HookProps, ReturnTuple>(usePostPartenerAccountUsersChangePassword);
